import React from 'react';
import { Navbar } from '../components/Navbar';
import { Stack } from '@mui/material';
import { Checklist as ChecklistComponent} from '../components/Checklist/Checklist';

// Page Devis
export const Checklist = (props) => {
    return (
		<Stack minWidth="100%" direction="row">
			<Navbar />
      		<ChecklistComponent />
		</Stack>
    );
};
